import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Card, EmptyState } from "@/components/common";

export default function Audit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit-logs").then(({ data }) => setRows(data)); }, []);
  return (
    <div>
      <PageHeader title="Audit Log" subtitle="Every major action, tracked" />
      <Card className="overflow-hidden">
        {rows.length === 0 ? <EmptyState text="No audit records." /> : (
          <div className="overflow-x-auto cc-scroll -m-5">
            <table className="w-full text-sm">
              <thead className="bg-zinc-50 text-zinc-500 text-xs uppercase">
                <tr><th className="text-left px-5 py-3">When</th><th className="text-left px-5 py-3">User</th><th className="text-left px-5 py-3">Action</th><th className="text-left px-5 py-3">Entity</th><th className="text-left px-5 py-3">Detail</th></tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id} className="border-t" data-testid={`audit-${r.id}`}>
                    <td className="px-5 py-3 font-mono text-xs text-zinc-500">{new Date(r.created_at).toLocaleString()}</td>
                    <td className="px-5 py-3 text-zinc-700">{r.user_name}</td>
                    <td className="px-5 py-3"><span className="text-xs px-2 py-0.5 bg-cc-blue/10 text-cc-blue rounded font-mono">{r.action}</span></td>
                    <td className="px-5 py-3 text-zinc-600">{r.entity_type}</td>
                    <td className="px-5 py-3 text-zinc-500 text-xs">{r.new_value ? JSON.stringify(r.new_value) : r.notes}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
